import { render } from "./SubnavPortfolio.vue?vue&type=template&id=63cfeb68"
import script from "./SubnavPortfolio.vue?vue&type=script&lang=ts"
export * from "./SubnavPortfolio.vue?vue&type=script&lang=ts"
script.render = render

export default script